import { useContext, useEffect, useState } from "react";
import { SiteSettingsContext } from "../context/SiteSettingsContext";
import { isNullOrWhiteSpace } from "../shared/string";
import useApi, { HttpError } from "./useApi";

type TickerData = {
    Instruments?: {
        ISIN?: string;
        MarketPlace?: string;
        TickerId?: number;
        TickerName?: string;
        TickerSymbol?: string;
        TickerType?: string;
        TradeCurrency?: string;
        Quotes?: {
            Delta?: number;
            DeltaPercentage?: number;
            AskPrice?: number;
            BidPrice?: number;
            HighPrice?: number;
            LowPrice?: number;
            OpenPrice?: number;
            Price?: number;
            Quantity?: number;
            QuoteTime?: string;
            QuoteType?: string;
            Turnover?: number;
            UnadjustedPrice?: number;
        }[];
    } [];
};

// type SharePerformanceData = {
//     Instruments?: {
//         ClosePrice1D?: number;
//         LastPrice?: number;
//         NumberOfShares?: number;
//         Symbol?: string;
//     }[];
// };

type ResultTicker = {
    delta?: number;
    deltaPercentage?: number;
    mCapTotalRaw: number;
    mMapTotalKilo: number;
    mMapTotalMega: number;
    price?: number;
    quoteTime?: string;
    tickerName?: string;
    tickerSymbol?: string;
    tradeCurrency?: string;
};


export type StockTickerData = {
    tickers: ResultTicker[];
};

const TICKER_REFRESH_TIME_MILLISECONDS = 15000;

const useStockTickerData = (): [StockTickerData | undefined, boolean, HttpError | undefined] | null => {
    const [retry, setRetry] = useState(false);
    const {
        integrationSettings
    } = useContext(SiteSettingsContext);

    let {
        active,
        url = "",
        accessToken = ""
    } = integrationSettings?.stockTicker || {};

    const invalidConfiguration = !active || isNullOrWhiteSpace(url) || isNullOrWhiteSpace(accessToken);

    let tickerUrl: string | null = null;

    if (!invalidConfiguration) {
        if (!url.endsWith("/")) {
            url = `${url}/`;
        }
        
        tickerUrl = `${url}Ticker/${accessToken}`;
    }


    const [tickerData, loading, error] = useApi<TickerData>({
        url: tickerUrl,
        retry
    });

    const computeTickerData = (data: TickerData) => {
        const sortedTickerInstruments = data.Instruments;
        
        // TODO: Weird sorting?
        // const sortedTickerInstruments = tickerData.Instruments.sort(function (a, b) {
        //     return a.TickerSymbol - b.TickerSymbol;
        // });

        return {
            tickers: sortedTickerInstruments?.map((instrument) => {
                const quote = instrument.Quotes?.find(_ => true);

                let deltaPercentage = 0;
                if (quote?.DeltaPercentage) {
                    deltaPercentage = quote.DeltaPercentage * 100;
                }

                // const performance = sharePerformanceData.Instruments[index];

                // const lastPrice = performance.LastPrice || performance.ClosePrice1D || -1;
                // const numberOfShares = performance.NumberOfShares || -1;
                // const marketCap = numberOfShares * lastPrice;

                return {
                    tickerName: instrument.TickerName,
                    tickerSymbol: instrument.TickerSymbol,
                    tradeCurrency: instrument.TradeCurrency,
                    delta: quote?.Delta,
                    deltaPercentage: deltaPercentage,
                    price: quote?.Price,
                    quoteTime: quote?.QuoteTime
                    // mCapTotalRaw: Math.round(marketCap),
                    // mMapTotalKilo: Math.round(marketCap / 1000),
                    // mMapTotalMega: Math.round(marketCap / 1000000)
                } as ResultTicker;
            }) ?? []
        };
    };

    useEffect(() => {
        let timer: number;

        const setTimer = () => {
            timer = window.setTimeout(() => {
                setRetry(old => !old); 
                setTimer();
            }, TICKER_REFRESH_TIME_MILLISECONDS);
        };

        setTimer();

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return [
        tickerData !== null ? computeTickerData(tickerData) : undefined,
        loading, 
        error
    ];
};

export default useStockTickerData;